import { SVGProps } from 'react';

const PersonStanding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9 20 3-6m0 0 3 6m-3-6v-4M6 8l6 2m0 0 6-2m-5-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default PersonStanding;
